import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Products.css"; // same styling use kar lenge

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const raw = localStorage.getItem("kwicth_wishlist");
      setItems(raw ? JSON.parse(raw) : []);
    } catch {
      setItems([]);
    }
  }, []);

  const removeFromWishlist = (id) => {
    const next = items.filter((it) => it.id !== id);
    setItems(next);
    localStorage.setItem("kwicth_wishlist", JSON.stringify(next));
  };

  const moveToProduct = (id) => {
    navigate(`/product/${id}`);
  };

  if (!items.length) {
    return (
      <main className="customer-root products-page" style={{ padding: 16 }}>
        <h1 className="prod-title-main">❤️ Wishlist</h1>
        <p style={{ marginTop: 12 }}>No items in wishlist.</p>
        <Link to="/products" style={{ marginTop: 12, display: "inline-block" }}>
          Browse products →
        </Link>
      </main>
    );
  }

  return (
    <main className="customer-root products-page" style={{ padding: 16 }}>
      <h1 className="prod-title-main">❤️ Wishlist</h1>

      <section className="prod-grid">
        {items.map((p) => (
          <article key={p.id} className="prod-card">
            <div
              className="prod-thumb-link"
              onClick={() => moveToProduct(p.id)}
            >
              <div className="prod-thumb">
                <img
                  src={p.image || "/images/placeholder.jpg"}
                  alt={p.name}
                  loading="lazy"
                />
              </div>
            </div>

            <div className="prod-body">
              <h3 className="prod-name">{p.name}</h3>
              <div className="prod-price">₹{p.price}</div>

              <div className="prod-actions">
                <button
                  className="prod-add"
                  onClick={() => removeFromWishlist(p.id)}
                >
                  ❌ Remove
                </button>
              </div>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}
